(function ($) {
	$(() => {
		const initializeCustomJavascriptFields = (form_id) => {
			$(window).trigger('fr:initialize-multiselect');

			//groups
			$(window).trigger('fr:initialize-atd-gf-media-field-group', [form_id]);

			//pseudo slide appender
			$.initialize('.atd-gf-slide-appender', function() {
				$(window).trigger('fr:initialize-atd-gf-pseudo-slide-appender', [form_id]);
			}, { target: document.getElementById('gform_wrapper_'+form_id) });

			//Synced Selects
			$.initialize('.atd-gf-synced-select', function() {
				$(window).trigger('fr:initialize-atd-gf-synced-selects', [form_id]);
			}, { target: document.getElementById('gform_wrapper_'+form_id) });

			//Custom Wysiwyg
			$(window).trigger('fr:initialize-atd-gf-custom-wysiwyg', [form_id]);

			//Repeater change label positioning
			$.initialize('.gfield--type-repeater:not(.fr-repeater-initialized)', function() {
				$(window).trigger('fr:initialize-atd-gf-change-label-position', [form_id]);
			}, { target: document.getElementById('gform_wrapper_'+form_id) });

			$(window).trigger('fr:initialize-atd-gf-prepopulate-fileupload', [form_id]);
/* 			$.initialize('.gfield--type-hidden:not(.fr-fileupload-initialized)', function() {
			}, { target: document.getElementById('gform_wrapper_'+form_id) }); */
		}

		// code to trigger on AJAX form render
		$(document).bind('gform_post_render', function(event, form_id, current_page){
			initializeCustomJavascriptFields(form_id);
		});

		gform.addFilter('gform_file_upload_markup', function (html, file, up, strings, imagesUrl, response) {
			//Path of your temp file
			var myFilePath = response.data.temp_preview_url;
			var formId = up.settings.multipart_params.form_id,
			fieldId = up.settings.multipart_params.field_id;
			var fid = "fid"+ Math.ceil((Math.random() * (10000 - 1000)) + 1000);
			
			//Converting Image to the base64
			function convertImgToBase64URL(url, callback, outputFormat){
				var img = new Image();
				img.crossOrigin = 'Anonymous';

				img.onload = function(){
					var canvas = document.createElement('CANVAS'),
					ctx = canvas.getContext('2d'), dataURL;
					canvas.height = (300 * img.height)/img.width;
					canvas.width = 300; //img.width;
					ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
					dataURL = canvas.toDataURL(outputFormat);
					callback(dataURL);
					canvas = null;
				};

				img.src = url;
			}
			
			convertImgToBase64URL(myFilePath, function(base64Img){
				var ffid = "#"+fid;
				$(ffid).attr("src", base64Img);
			});
			
			html = '<img id="'+fid+"\" src='' class='atd-gf-thumb' /><img class='gform_delete' src='" + imagesUrl + "/delete.png' onclick='gformDeleteUploadedFile(" + formId + "," + fieldId + ", this);' alt='" + strings.delete_file + "' title='" + strings.delete_file + "' />";
			return html;
		});
	});
})(jQuery);